import axios from "axios";
const API_BASE_URL = "https://fishbot-backend.herokuapp.com/";

export const coinHighscoresApi = axios.create({
  baseURL: API_BASE_URL + "topapi",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
